export default __webpack_public_path__ + "static/media/background-login-empresa.4d757b8f.jpg";